export const getArchiveUrl = (sectionUrl: string, year: string, month: string) =>
  `${sectionUrl}/archive/${year}/${month}`;
